import { useState } from "react";
import LedgerIcon from "../../../assets/svg/ledger.svg";
import ResizeListener from "../../../utility/ResizeListener";
import BodyComponent from "../../components/BodyComponent";
import SidebarLayout from "../../components/SidebarLayout";
import { LEDGER_TAB } from "../../resources/constantsManager";
import Ledger from "./ledger";
import Settlement from "./settlement";

const FinanceCenter = () => {
  const [currentTab, setCurrentTab] = useState(LEDGER_TAB);
  const [filterOpened, setFilterOpened] = useState(false);
  const { height } = ResizeListener();

  const FinanceMenu = [
    {
      name: "Ledger",
      icon: LedgerIcon,
      key: LEDGER_TAB,
    },
    // {
    //   name: "Settlement",
    //   icon: SettlementIcon,
    //   key: SETTLEMENT_TAB,
    // },
  ];
  return (
    <>
      <SidebarLayout
        menu={FinanceMenu}
        passCurrentTab={(tab) => {
          setCurrentTab(tab);
        }}
        activeTab={currentTab}
      />
      <BodyComponent
        style={{
          height: filterOpened ? height : height * 0.85,
          transition: "height 0.5s ease-out",
        }}
      >
        {currentTab === LEDGER_TAB ? (
          <Ledger
            filterOpened={(data) => {
              setFilterOpened(data);
            }}
          />
        ) : (
          <Settlement />
        )}
      </BodyComponent>
    </>
  );
};

export default FinanceCenter;
